import React from 'react'
import styled from '@emotion/styled'
import ThemeSelector from 'src/components/ThemeSelector'
import SanityRichText from 'src/components/SanityRichText'
import { typography, util } from 'src/styles'
import AnimateHeight from 'react-animate-height'

const NotificationCollapse = styled(AnimateHeight)`
	position: relative;
`

const Wrapper = styled(ThemeSelector)`
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	padding: 0 var(--site-margins);
	p {
		margin: 0;
		padding: .5em 0 .6em;
		${ typography.bodySmall }
		${ util.responsiveStyles('font-size', 14, 13, 12, 11) }
		line-height: 1.3em;
	}
`

const NotificationBanner = ({ className, setTheme, text, collapsed }) => {
	let bannerColor = setTheme
	if (setTheme === null) {
		bannerColor = 'mainColor'
	}

	return (
		<NotificationCollapse
			duration={300}
			delay={0}
			animateOpacity={false}
			height={collapsed ? 0 : 'auto'}
		>
			<Wrapper className={className} setTheme={bannerColor}>
				{text.raw ? (<SanityRichText richText={text}/>) : <p>{text}</p>}
			</Wrapper>
		</NotificationCollapse>
	)
}

NotificationBanner.defaultProps = {
	setTheme: 'greenBright',
	collapsed: false
}

export default NotificationBanner
